import { StoreView } from './storeViews'

const getStoreLanguage = (storeView: StoreView) => {
  const forcedLanguage = process.env.REACT_APP_FORCE_LANG
  if (forcedLanguage) {
    return forcedLanguage
  }
  const { locale, language } = storeView
  if (locale) {
    return locale
  }
  if (language) {
    return language
  }
  // This should only be possible to happen (when accounting for type errors)
  // if language is an empty string ''
  throw new Error(
    'Cannot find a locale or fallback language in the active storeView!',
  )
}

export default getStoreLanguage
